const { empty } = require('./booking-detail')
const { invoiceTotal } = require('./booking-invoice')
const { deadlinePayload } = require('./booking-manual-actions')

function previousPaymentErrors(draft) {
  const errors = {}
  if (empty(draft.amount)) errors.amount = 'This field is required.'
  else if (invoiceTotal(draft.amount) === null || Number(draft.amount) <= 0) errors.amount = 'Enter an amount greater than zero, with up to 12 digits before the decimal point and 2 after it.'
  if (empty(draft.occured_at)) errors.occured_at = 'This field is required.'
  else if (!deadlinePayload(draft.occured_at)) errors.occured_at = 'Enter a valid date and time.'
  if (empty(draft.description)) errors.description = 'This field is required.'
  return errors
}

function previousPaymentPayload(draft) {
  return {
    event_type: 'opening_payment',
    amount: invoiceTotal(draft.amount),
    occured_at: deadlinePayload(draft.occured_at),
    description: String(draft.description || '').trim()
  }
}

module.exports = { previousPaymentErrors, previousPaymentPayload }
